<div class="page-container container ck-content">
  <!-- prettier-ignore -->
  <div #legalContent></div>
</div>
